import React, { Component } from 'react';
import { Table, Menu, Icon, Label, Button, Popup, Grid, } from 'semantic-ui-react'
import { Link } from 'react-router-dom';
import * as algoliasearch from 'algoliasearch';
import { firebaseAuth, base, orderStatusOptions, algoliaKey, alogoliaAccount  } from '../../config/constants.js'
import { log } from '../../Utilities/Utils'
import * as UiConsts from '../../config/UiConstants'
import * as FbUtils from '../../Utilities/FireBaseUtils'
import Select from 'react-select';
import { VerifyOrderButton } from './newDashboard/DashboardParts'
import Status from '../../config/OrderStatusConstants'
import OrderCard from './newDashboard/OrderCard'
import { sendNewOrder } from './newDashboard/Reporting/ReportingUtils'
import { getDesigners } from './newDashboard/algoliaDashboard/AlgoliaMiscUtils'
import {getSalesPeople, getDeliveryGuys} from '../dashBoard/newDashboard/LargeProjects/ApiUtils'
import { getSalesPeopleDropDown, getDeliveryGuysDropdown } from '../dashBoard/newDashboard/LargeProjects/LargeProjectUtils'



export default class OrderTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: '',
            userFromFirebaseNode: '',
            loading: true,
            orderList: [],
            deliveryPeople: [],
            designers: [],
            salesPeopleChoices:[],
            deliveryPersonChoices:[],
        }
    }

    componentDidMount() {
        console.log("ordertable: componentDidMount++++++++: orderType:" + this.props.orderType);
        firebaseAuth().onAuthStateChanged((user) => {
            if (user) {
                //console.log("user is signed in:" + user.uid);
                this.setState({
                    user: user,
                    userFromFirebaseNode: user,
                    loading: false
                })

            } else {
                log("user is NOT signed in:" + user.uid);
            }
        });

        /**
         * SYNC WITH ORDERS NODE
         */
        this.syncOrders(this.props.orderType);

        //GET DELIVERY PEOPLE
        // base.fetch('admin/deliveryPeople', {
        //     context: this,
        //     asArray: true,
        //     then(data) {
        //         // console.log(data);
        //         this.setState({
        //             deliveryPeople: data
        //         })
        //     }
        // });

        //SEND TO API ARCHIVE OLD ORDERS
         //this.sendOrdersToApi();

        //LOAD DESIGNERS
        this.loadDesigners();
        getSalesPeople(this.loadSalesPeople);
        getDeliveryGuys(this.loadDelGuys);

    }

    loadDelGuys = (delGuys) => {
      //  console.log("getDelguys ++++++++:loadSalesPeopleDropdown");
       // console.log("getdelguys:"+JSON.stringify(delGuys,null,3));
        if(delGuys && delGuys.length > 0){
            console.log("getdelguys customer dropdown...")
            this.setState({
                deliveryPersonChoices: getDeliveryGuysDropdown(delGuys)
            })
        }else{
            alert("unable to load delivery people")
        }
    }


    loadSalesPeople = (salesPeople) => {
        console.log("getSales2 ++++++++:loadSalesPeopleDropdown");
      //  console.log("getSales22:"+JSON.stringify(salesPeople,null,3));
        if(salesPeople && salesPeople.length > 0){
            console.log("getSales23 customer dropdown...")
            this.setState({
                salesPeopleChoices: getSalesPeopleDropDown(salesPeople)
            })
        }else{
            alert("unable to load salespeople")
        }
    }

    syncOrders = (orderType) => {
        console.log("sx1 +++++++:syncOrders");
        base.syncState('orders', {
            context: this,
            state: 'orderList',
            asArray: true,
            queries: {
                orderByChild: 'invalid',
                equalTo: null
            }
        });
    }

    /**
     * testin reporting api
     */
    sendOrdersToApi = () => {
        console.log("++++++++++++:sendOrdersToApi");

        base.fetch('orders', {
            context: this,
            asArray: true,
            queries: {
                limitToLast: 3
              },
            then(data) {
                let allOrders = data;
                console.log("apx1: length:" + allOrders.length);
                console.log("apx1: length - 522:" + (allOrders.length - 122));

                let i = 0;
                for (i = (allOrders.length - 500); i < allOrders.length; i++) {
                    // for (i = 200; i < allOrders.length; i++) {
                   // console.log("apx12 - i:" + i + " - " + allOrders[i].order_num);
                    // console.log("apx121 order:"+allOrders[i].key+" - "+allOrders[i].order_num);

                    sendNewOrder(allOrders[i]);
                }
            }
        });
    }

    loadDesigners = () => {
        //console.log("aglx922:-----: loadDesigners calling getDesigners");


        var client = algoliasearch(alogoliaAccount, algoliaKey);
        var index = client.initIndex('printb_values');

        index.search({
            query: '',
            //  facetQuery: '',
            filters: 'grouping:design'
        }).then(content => {
           // console.log("aglx91:" + JSON.stringify(content.hits, null, 3));

            this.setState({
                designers: content.hits
            });


        }).catch(function (err) {
            console.log(err);
            console.log(err.debugData);

        });

    }

    render() {

        // console.log("order list px1x:"+JSON.stringify(this.state.orderList));

        const numOrderheader = (
            <h2>{this.state.orderList.length} orders</h2>
        )

       // const userConst = this.state.userFromFirebaseNode == null ?
        const userConst = this.props.user == null ?
            <h5>no user</h5> :
            <h5>user:{this.props.user.email}</h5>

        //const OrderCardList = this.state.userFromFirebaseNode ? this.state.orderList.map((order) =>
        const OrderCardList = this.props.algoliaUser.isAdmin ? this.state.orderList.map((order) =>
            order.status === this.props.orderType
                || order.itemType === this.props.orderType
                || (this.props.orderType === 'all' && order.status !== Status.delivered) ?

                <Grid.Column>
                    <OrderCard
                        //user={this.state.userFromFirebaseNode}
                        user={this.props.user}
                        order={order}
                        deliveryPeople={this.state.deliveryPeople} 
                        designers={this.state.designers}
                        orderStatuses={this.props.orderStatuses}
                        algoliaUser = {this.props.algoliaUser}
                        salesPeopleChoices = {this.state.salesPeopleChoices}
                        deliveryPersonChoices = {this.state.deliveryPersonChoices}/>
                </Grid.Column>

                : ""
        )
            : ""

        return (
            <div>
                <h5>orderType:{this.props.orderType}</h5>
                {userConst}
                {numOrderheader}
                <Grid stackable columns={3}>
                    {OrderCardList}
                </Grid>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/dashBoard/OrderTable.js